field1 = document.getElementById('field1')
field2 = document.getElementById('field2')
field3 = document.getElementById('field3')
field4 = document.getElementById('field4')

/*
function updateFields () {
    var brutto = field1.value
    var result = brutto * 1.19
    if (String(result) != 'Infinity' && String(result) != 'NaN') {
        field3.value = (Math.round(result*100)/100)
    }
}
*/

setInterval(() => {
    var netto = field1.value
    var steuersatz = field2.value
    var prozentsatz = 1 + (field2.value / 100)
    console.log(prozentsatz)
    var brutto = netto * prozentsatz
    var result = brutto
    if (String(result) != 'Infinity' && String(result) != 'NaN') {
        field3.value = (Math.round(result*100)/100)
    }

    if (String(result) == '0') {
        field3.value = ''
    }

    var mehrwertsteuer = brutto - netto
    field4.value = Math.round(mehrwertsteuer*100)/100
    if (String(result) == '0') {
        field4.value = ''
    }
}, 500);